// extracted by mini-css-extract-plugin
export default {"actionContainer":"styles-module__actionContainer__src-labstep-web-components-ProtocolValue-Detail-ResourceItem-Input-_owuhl"};